export default "__VITE_ASSET__KAajNd_n__"